const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"045ec79e365db4aabdfe1d9a2665376e41b86c9f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["filmine@filmine"]={id:"045ec79e365db4aabdfe1d9a2665376e41b86c9f"};
      